import { render, staticRenderFns } from "./FormSubNotDanger.vue?vue&type=template&id=58a9c19e"
import script from "./FormSubNotDanger.vue?vue&type=script&lang=js"
export * from "./FormSubNotDanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports